// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"c406ebc1","149":"d21da41d","220":"138dda7e","385":"f9d65abc","426":"07ad963a","430":"c61ddb3f","463":"757519f4","585":"2f3e7792","887":"1cbc3303","913":"a47de463"}[chunkId] + ".chunk.css";
};